import { Utils } from "./utils";
let carouselTimeoutHandler;
//******************** Carousel Initialisation Functions ********************//
/**
 * Initialises the carousel by setting up the cards, indicators and togglers.
 * @param carousel Element to initialise the carousel for.
 */
function InitialiseCarousel(carousel) {
    // Initialise the carousels components
    InitialiseCarouselCards(carousel); // Cards created for scrolling through
    InitialiseCarouselTogglers(carousel); // Toggles for clicking through the carousel rather than swiping, using the indicator dots or clicking the next card.
    InitialiseCarouselIndicators(carousel); // Indicator dots showing how far through the carousel you are
    // Retrieve the items from the carousel
    const carouselItems = carousel.querySelector(".carousel-items");
    // If the carousel cards are invalid return as we can't do anything with them
    if (carouselItems === null) {
        return;
    }
    // Update the initial carousel cards states, focused or not
    UpdateCarousel(carousel);
    window.addEventListener("resize", () => {
        UpdateCarousel(carousel); // Update the carousel on resize to ensure the cards are still focused correctly
    });
    //When the carousel is scrolled
    carouselItems.onscroll = function () {
        UpdateCarouselCards(carousel); // Update the Carousel cards states, focused or not
        // When the carousel is scrolled, set a timeout to update the carousel after a short delay
        // since this will be called multiple times during a scroll event clear the timeout every time
        // the scroll event is triggered to prevent multiple updates leaving only the final one to trigger.
        window.clearTimeout(carouselTimeoutHandler);
        carouselTimeoutHandler = window.setTimeout(() => { UpdateCarousel(carousel, true); }, 100);
    };
    // After the carousel has finished scrolling
    carouselItems.addEventListener("scrollend", () => {
        UpdateCarousel(carousel, true);
    });
}
;
//******************** Carousel Cards Initialisation ********************//
/**
 * Initialise the base states of the carousels cards giving them their onclick events and focused states.
 * @param carousel The Element matching the carousel containing all the cards for retrieving the card Elements.
 */
function InitialiseCarouselCards(carousel) {
    // Retrieve all the card Elements from the provided carousel
    const carouselCards = carousel.querySelectorAll(".carousel-card");
    // Loop through each card in the NodeList and initialise them with focused states and onclick events.
    carouselCards.forEach(card => {
        InitialiseCarouselCard(card, carousel); // Provide the carousel Cards with their onlick events
        UpdateCarouselCard(card, carousel); // Update the carousel Card with its focused state
    });
}
;
/**
 * Updates the provided card with an onlick listener for card specific functionality.
 * @param card HTMLElement Card for attaching onclick listeners to.
 * @param carousel Carousel passed along for use within the cards onclick functionality to target the correct carousel.
 */
function InitialiseCarouselCard(card, carousel) {
    card.onclick = function () {
        var _a;
        const cardIndex = (_a = card.dataset.cardIndex) !== null && _a !== void 0 ? _a : ""; // Get Cards index from data attribute
        // If card dosent have focused class and has a cardIndex then run functionality.
        if (card.classList.contains("focused") || cardIndex === "") {
            return;
        }
        // On click focus the card index provided
        FocusCard(cardIndex, carousel);
    };
}
;
//******************** End of Carousel Cards Initialisation ********************//
//******************** Carousel Togglers Initialisation ********************//
/**
 * Initialising the carousels toggler buttons for paging through the carousels content.
 * @param carousel Parent Carousel for getting the related togglers and use within each toggler initialisation function.
 */
function InitialiseCarouselTogglers(carousel) {
    const togglers = carousel.querySelectorAll(".carousel-toggler");
    togglers.forEach(toggler => {
        InitialiseCarouselToggler(toggler, carousel); // Attach the toggler's onclick functionality to the toggler
        UpdateCarouselToggler(toggler, carousel); // Set initial state of carousel togglers disabled or enabled
    });
}
;
/**
 * Taking in a toggler element and parent carousel initialise the toggler with its onlick functionality.
 * @param toggler Toggler HTML Element to be updated with onlcick functionality.
 * @param carousel Parent carousel for use within Togglers onlcick functionality.
 */
function InitialiseCarouselToggler(toggler, carousel) {
    toggler.onclick = function () {
        var _a, _b, _c;
        // Retrieve the direction of provided toggler
        const direction = (_a = toggler.dataset.direction) !== null && _a !== void 0 ? _a : "";
        // if toggler is disabled does nothing
        if (toggler.classList.contains("disabled")) {
            return;
        }
        // Retrive carousel cards from parent carousel
        const carouselCards = carousel.querySelector(".carousel-items");
        // If the carousel cards are invalid return as we can't do anything with them
        if (carouselCards === null) {
            return;
        }
        // Retrieve focused cards within parent carousel
        const focusedCards = carouselCards.querySelectorAll(".carousel-card.focused");
        if (direction === "forward") {
            // get the index of the last card within focused cards and add 1 to target first unfocused card after last focused card
            const cardIndex = (parseInt((_b = focusedCards[focusedCards.length - 1].dataset.cardIndex) !== null && _b !== void 0 ? _b : "0") + 1).toString();
            FocusCard(cardIndex, carousel); // Focus the card after the last focused card onclick
        }
        else if (direction === "back") {
            // get the index of the first card within focused cards and minus 1 to target first unfocused card before the first focused card
            const cardIndex = (parseInt((_c = focusedCards[0].dataset.cardIndex) !== null && _c !== void 0 ? _c : "0") - 1).toString();
            FocusCard(cardIndex, carousel); // Focus the card before the first focused card onclick
        }
    };
}
;
//******************** End of Carousel Togglers Initialisation ********************//
//******************** Carousel Indicators Initialisation ********************//
/**
 * Initilaised the carousels indicator dots, highlighting the dots relating to the focused cards.
 * @param carousel Taking in the indicators parent carousel for finding the indicators.
 */
function InitialiseCarouselIndicators(carousel) {
    // Retrieve all indicators from given carousel
    const carouselIndicators = carousel.querySelectorAll(".carousel-indicator");
    // Loop through each indicator and initialise them
    carouselIndicators.forEach(indicator => {
        InitialiseCarouselIndicator(indicator, carousel); // initialise each indicator with it's onclick functionality
    });
}
;
/**
 * Taking in an indicator Element and parent carousel Element initialises each indicator dot with its onclick functionality.
 * @param indicator HTMLElement for an indicator dot relating to a card within the carousel to have onclick functionality applied to.
 * @param carousel Parent Carousel Element of indicator dits to be used within the indicators inclick functionality.
 */
function InitialiseCarouselIndicator(indicator, carousel) {
    indicator.onclick = function () {
        var _a;
        // If the indicator is focused shouldn't do anything when clicked
        if (indicator.classList.contains("focused")) {
            return;
        }
        // Retrieve the index of the indicators related card
        const cardIndex = (_a = indicator.dataset.cardIndex) !== null && _a !== void 0 ? _a : "";
        if (cardIndex === "") {
            return; // If the card index is invalid return as we can't focus a card
        }
        // if the card index is valid when the indicator is clicked focus the related card passing the parent carousel.
        FocusCard(cardIndex, carousel);
    };
}
;
//******************** End of Carousel Indicators Initialisation ********************//
//******************** End of Carousel Initialisation Functions ********************//
//******************** Carousel Update Functions ********************//
/**
 * Updates the carousel cards focused states, the indicators to match the current position of the carousels
 * cards and the toggler buttons to be enabled or disabled.
 * @param carousel Element to update the carousel for.
 * @param scrollTriggered If the update is being triggered by a scroll event, this will be true, otherwise false.
 */
function UpdateCarousel(carousel, scrollTriggered = false) {
    var _a;
    UpdateCarouselCards(carousel); // Update the carousel cards focused states
    // Retrieve all the focused cards and the index of the last of the focused cards
    const focusCards = carousel.querySelectorAll(".carousel-card.focused");
    // If there are no focused cards return as we can't update the indicators or togglers
    if (focusCards.length <= 0) {
        return;
    }
    const cardIndex = (_a = focusCards[focusCards.length - 1].dataset.cardIndex) !== null && _a !== void 0 ? _a : "";
    // If no card is focused return as we can't update the indicators or togglers
    if (cardIndex === "") {
        return;
    }
    UpdateCarouselTogglers(carousel); // Update the carousel toggler buttons disabled and enabled states
    UpdateCarouselIndicators(parseInt(cardIndex), carousel, scrollTriggered); // Update the carousel indicators to match the current position of the carousels cards
    UpdateCarouselIndicatorsStates(carousel); // Update the carousel indicators states based on the focused state of the cards
}
;
//******************** Carousel Cards Updates ********************//
/**
 * Updated the carousel cards focused and unfocused states.
 * @param carousel parent carousel contianing all the carousel cards.
 * @param updateIndicators when false dosen't update the carousel indicators under the cards.
 */
function UpdateCarouselCards(carousel) {
    // Retrieve the carousel cards from the parent carousel
    const carouselCards = carousel.querySelectorAll(".carousel-card");
    carouselCards.forEach(card => {
        // Update the current state of each carousel card
        UpdateCarouselCard(card, carousel);
    });
}
;
/**
 * Finds the visibility of each carousel card in the viewport and applied focused or unfocused classes accordingly.
 * @param card The specific card being checked by this function to get it's state updated.
 * @param carousel The parent carousel of the provided card.
 * @param updateIndicators Optional flag for if the carousels indicators should be updated with the card.
 */
function UpdateCarouselCard(card, carousel) {
    // Find out if the card is visible within the viewport horizontally ignoring the vertical viewport
    // If the carouselVertical attribute is present it will return an empty string otherwise it will return null.
    const horizontalOnly = carousel.dataset.carouselVertical === null;
    const verticalOnly = carousel.dataset.carouselVertical === "";
    // If the card is visible within the viewport horizontally or vertically add focused class
    if (Utils.IsVisibleInContainer(card, carousel, horizontalOnly, verticalOnly)) {
        // If card is visible within the viewport add focused class
        card.classList.add("focused");
    }
    else {
        card.classList.remove("focused");
    }
}
;
//******************** End of Carousel Cards Updates ********************//
//******************** Carousel Togglers Updates ********************//
/**
 * Updates carousel togglers for provided parent carousel disabling and enabling depending on carousel position.
 * @param carousel Parent carousel for retrieveing carousel togglers and processing within UpdateCarouselToggler function.
 */
function UpdateCarouselTogglers(carousel) {
    const togglers = carousel.querySelectorAll(".carousel-toggler");
    togglers.forEach(toggler => {
        // Update each individual toggler functionality
        UpdateCarouselToggler(toggler, carousel);
    });
}
;
/**
 * Updates provided carousel toggler button's disabled and enabled state depending on the togglers
 * direction and the position of the focused cards in the cards array.
 * @param toggler HTMLElement toggler for updating depending on array position.
 * @param carousel Parent Carousel Element for use when getting related Elements.
 */
function UpdateCarouselToggler(toggler, carousel) {
    var _a;
    // Retrieves which direction the toggler affects from element
    const direction = (_a = toggler.dataset.direction) !== null && _a !== void 0 ? _a : "";
    // Retrieve cards from parent Carousel
    const carouselCards = carousel.querySelector(".carousel-items");
    if (carouselCards === null) {
        return;
    }
    const cards = carouselCards.querySelectorAll(".carousel-card");
    const focusedCards = carouselCards.querySelectorAll(".carousel-card.focused");
    if (direction === "forward") {
        // If the current last focused card is the same element as the last card
        if (focusedCards[focusedCards.length - 1] == cards[cards.length - 1]) {
            toggler.classList.add("disabled"); //disables the toggler
        }
        else {
            toggler.classList.remove("disabled"); // otherwise enables the toggler
        }
    }
    else {
        // if the first focused card is the same element as the first card
        if (focusedCards[0] == cards[0]) {
            toggler.classList.add("disabled"); //disables the toggler
        }
        else {
            toggler.classList.remove("disabled"); // otherwise enables the toggler
        }
    }
}
//******************** End of Carousel Togglers Updates ********************//
//******************** Carousel Indicators Updates ********************//
/**
 * Updates the carousels indicators states scrolling their parent container as needed to keep
 * them focued within the reduced size container.
 * @param cardIndex String Index of the card focused.
 * @param carousel Parent carousel for retrieving related elements.
 * @param scrollTriggered Optional Boolean flag dictating if the function was triggered by scroll or not.
 */
function UpdateCarouselIndicators(cardIndex, carousel, scrollTriggered = false) {
    var _a, _b;
    // retrieve all the carousels indicators from parent carousel
    const indicatorCarousel = carousel.querySelector(".carousel-card-indicators");
    // If indicator carousel is valid begin processing otherwise return as we can't do anything with it
    if (indicatorCarousel === null) {
        return;
    }
    // retrieve indicators from indicator carousel and the focused indiators
    const indicators = indicatorCarousel.querySelectorAll(".carousel-indicator");
    const focusedIndicators = indicatorCarousel.querySelectorAll(".carousel-indicator.focused");
    // Retrieve the size and gap of the indicators for use when scrolling parent container
    const indicatorCarouselStyles = window.getComputedStyle(indicatorCarousel);
    const indicatorSize = Utils.convertRemToPixels(parseFloat(indicatorCarouselStyles.getPropertyValue("--indicator-size").replace("rem", "")));
    const indicatorGap = Utils.convertRemToPixels(parseFloat(indicatorCarouselStyles.getPropertyValue("--indicator-gap").replace("rem", "")));
    const moveDistance = indicatorSize + indicatorGap;
    // Retreieve focused bounds as numbers for processing
    let lastFocusIndex = parseInt("");
    let firstFocusIndex = parseInt("");
    if (focusedIndicators.length > 0) {
        lastFocusIndex = parseInt((_a = (focusedIndicators[focusedIndicators.length - 1]).dataset.cardIndex) !== null && _a !== void 0 ? _a : "");
        firstFocusIndex = parseInt((_b = (focusedIndicators[0]).dataset.cardIndex) !== null && _b !== void 0 ? _b : "");
    }
    // if selected card is greater than the last focused card we are moving down the array
    if (lastFocusIndex > cardIndex) {
        // Move multiplier is used to scroll multiple indicators at a time
        let moveMultiplier = firstFocusIndex - cardIndex;
        if (scrollTriggered) {
            moveMultiplier = lastFocusIndex - cardIndex;
        }
        if (focusedIndicators[focusedIndicators.length - 1] == indicators[indicators.length - 1]) {
            moveMultiplier -= 1;
        }
        // As we are moving down the array comparison is made against the first focused node
        indicatorCarousel.scrollLeft -= moveDistance * moveMultiplier;
    }
    else {
        let moveMultiplier = cardIndex - lastFocusIndex;
        if (focusedIndicators[0] == indicators[0]) {
            moveMultiplier -= 1;
        }
        // As we are moving up the array comparison is made against the last focused node
        indicatorCarousel.scrollLeft += moveDistance * moveMultiplier;
    }
}
;
/**
 * Updates the states of the carousels indicators based on the focused state of the cards.
 * @param indicators NodeListOf<Element> of the carousels indicators to be updated.
 * @param carousel Parent carousel for retrieving related elements.
 */
function UpdateCarouselIndicatorsStates(carousel) {
    const indicatorCarousel = carousel.querySelector(".carousel-card-indicators");
    if (indicatorCarousel === null) {
        return;
    }
    const indicators = indicatorCarousel.querySelectorAll(".carousel-indicator");
    indicators.forEach(indicator => {
        var _a;
        const index = (_a = indicator.dataset.cardIndex) !== null && _a !== void 0 ? _a : "";
        // If the index is invalid return as we can't do anything with it
        if (index === "") {
            return;
        }
        // Retrieve the card related to the indicator from the parent carousel
        const card = carousel.querySelector(`.carousel-card[data-card-index="${index}"]`);
        // If the card is invalid return as we can't do anything with it
        if (card === null) {
            return;
        }
        if (card.classList.contains("focused")) {
            indicator.classList.add("focused");
        }
        else {
            indicator.classList.remove("focused");
        }
    });
}
;
//******************** End of Carousel Indicators Updates ********************//
//******************** End of Carousel Update Functions ********************//
//******************** Carousel Functionality Functions ********************//
/**
 * Taking in a cardIndex and carousel element focues card related to provided card index within the given carousel.
 * @param cardIndex CardIndex string relating to a card within the carousel to be focued.
 * @param carousel Parent carousel of the card relating ot cardIndex variable
 */
function FocusCard(cardIndex, carousel) {
    // Find card relating to given index
    const card = carousel.querySelector(`.carousel-card[data-card-index="${cardIndex}"]`);
    //If the card is invalid return otherwise focus the card within it's parent scrollable container
    if (card === null) {
        return;
    }
    const verticalCarousel = carousel.classList.contains("vertical") || carousel.dataset.carouselVertical === "";
    // On some devices scrollIntoView may be buggy so use manual scrolling first
    // Get Parent scrollable container
    const parentElement = card.parentElement;
    // if no parent element return as we can't scroll
    if (parentElement === null) {
        return;
    }
    // Move distance is the cards height + gap between cards
    let moveDistance = Utils.convertRemToPixels(window.getComputedStyle(carousel).getPropertyValue("--column-gap"));
    moveDistance += verticalCarousel ? card.clientHeight : card.clientWidth;
    // If the previous card is focused or null we are moving down the carousel and need to scroll down
    // If the previous card is focused or null we are moving to the right of the carousel and need to scroll right
    let scrollTo = verticalCarousel ? parentElement.scrollTop : parentElement.scrollLeft;
    // If the previous card is focused, we are moving down the carousel, otherwise we are moving up
    if (card.previousElementSibling ? card.previousElementSibling.classList.contains("focused") : true) {
        scrollTo += moveDistance;
    }
    else {
        scrollTo -= moveDistance;
    }
    // Scroll the parent element to the calculated scrollTo position first before focusing the card
    if (verticalCarousel) {
        parentElement.scrollTo({ top: scrollTo, behavior: 'smooth' });
    }
    else {
        parentElement.scrollTo({ left: scrollTo, behavior: 'smooth' });
    }
    // Attempt to focus the card automatically after scrolling
    card.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "nearest" });
    // Update the carousel focused states
    UpdateCarousel(carousel);
}
;
//******************** End of Carousel Functionality Functions ********************//
export class Carousel {
    /**
     * Exports the Initialise Carousel Functionality to be used by other scripts bulk initialising carousels.
     * Should only run a single time per page.
     */
    InitialiseCarousels() {
        // All carousels are found on the page
        const carousels = document.querySelectorAll(".carousel");
        // Loop through the carousels to initialise them all
        carousels.forEach(carousel => {
            InitialiseCarousel(carousel);
        });
    }
    ;
    /**
     * Exports the update carousel function to be used by other scripts bulk updating carousels.
     * Can run as many times as needed.
     */
    UpdateCarousels() {
        // All carousels are found on the page
        const carousels = document.querySelectorAll(".carousel");
        const scrollTriggered = false;
        // Loop through all the carousels to update them all
        carousels.forEach(carousel => {
            this.UpdateCarousel(carousel, scrollTriggered);
        });
    }
    ;
    /**
     * Exports the update carousel function to be used by other scripts.
     * Can run as many times as needed.
     * @param carousel The carousel that should be updated
     * @param scrollTriggered A boolean to determin if the update was triggered by a scroll event
     */
    UpdateCarousel(carousel, scrollTriggered = false) {
        UpdateCarousel(carousel, scrollTriggered);
    }
    ;
}
